import img from 'src/public/img/mh-logo-text-modern-health.svg';
import styled from '@emotion/styled';

const BrandImageContainer = styled.img({
    width: '10em',
    height: '100%',
});

const LargeBrandImageContainer = styled.img({
    width: '12em',
    margin: '1.5em 0 0 1.5em',
});

export const BrandImage = () => <BrandImageContainer src={img} alt="Modern Health" />;
export const LargeBrandImage = () => <LargeBrandImageContainer src={img} alt="Modern Health" />;
